import { FC, useState } from 'react';
import cn from 'classnames';
import Image from 'next/image';

type IFrameProps = {
  url: string;
  width: string | number;
  height: string | number;
  rounded?: boolean;
  loading?: 'eager' | 'lazy';
  epigraph?: string;
  placeholder?: {
    src: string;
    alt: string;
    width: number;
    height: number;
  };
};

const IFrame: FC<IFrameProps> = ({
  url,
  width,
  height,
  rounded = false,
  loading = 'eager',
  epigraph,
  placeholder
}) => {
  const [placeHolderWasHovered, setPlaceHolderWasHovered] = useState(false);

  return (
    <div>
      <div className={cn('overflow-hidden', rounded && 'rounded-2xl')}>
        {placeholder && !placeHolderWasHovered ? (
          <Image
            style={{ maxHeight: height }}
            onMouseEnter={() => setPlaceHolderWasHovered(true)}
            quality={100}
            src={placeholder.src}
            alt={placeholder.alt}
            width={placeholder.width}
            height={placeholder.height}
            className="object-cover w-full"
          />
        ) : (
          <iframe width={width} height={height} src={url} loading={loading} />
        )}
      </div>
      {epigraph && (
        <p className="mt-6 lg:mt-5 text-sm lg:text-base lg:tracking-[-0.01em] text-neutral-400">
          {epigraph}
        </p>
      )}
    </div>
  );
};

IFrame.defaultProps = {
  url: 'https://lidar-viewer-git-gis-viewer-scaleai.vercel.app/embed?url=demo_scene_1/scene.json',
  width: '100%',
  height: 700
};

export default IFrame;
